module.exports = __webpack_public_path__ + "static/media/slack_notification_configured_ja.10d09ed4.png";